<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
{{ $.row[$.adata.keyName] | rruleParser }} <br> 
 {{ setFullDate($.row[$.adata.startTime]) | datetimeformat  : 'shortTime' }} - {{ setFullDate($.row[$.adata.endTime]) | datetimeformat  : 'shortTime' }} 
</ng-container>